import React from 'react';
import { l10nEnService } from '@uplift/services';
import { Typography, TypographyProps } from '@mui/material';


export function useL10n() {
  return l10nEnService;
}

export type L10n = ReturnType<typeof useL10n>;

export type L10nHTMLProps = Omit<TypographyProps, 'component' | 'children' | 'dangerouslySetInnerHTML'> & {
  children: string;
};

export const L10nHTML: React.VFC<L10nHTMLProps> = ({ children, ...props }) => {
  const html = React.useMemo(() => children, [ children ]);

  return (
    <Typography {...props} component="span" dangerouslySetInnerHTML={{ __html: html }} />
  );
};
